<template>
  <div class="rich-content">
    <component v-for="(block, index) in blocks" :key="index" :is="getBlockComponent(block.type)" :block="block" />
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import RichTextBlock from '@/components/richContent/RichTextBlock.vue';
import RichImageBlock from '@/components/richContent/RichImageBlock.vue';

defineProps({
  blocks: {
    type: Array,
    required: true,
  },
});

const getBlockComponent = (type) => {
  return (
    {
      text: RichTextBlock,
      image: RichImageBlock,
    }[type] || 'div'
  );
};
</script>

<style scoped>
.rich-content {
  width: 100%;
}
</style>
